import { toast } from 'react-toastify';

import { uniqueId } from 'lodash';
import api from '../../api';
import { Note } from './types';

export async function getNotesRequest() {
  try {
    const response = await api().get(`/notes`);

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getNotesByIdRequest(noteId: string) {
  try {
    const response: Note = await api().get(`/notes/${noteId}`);

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getNotesByUserIdRequest(userId: string, search: string) {
  try {
    const response = await api().get(`/notes/user/${userId}`, {
      params: {
        search,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getNotesByUserIdAndMeetingIdRequest(
  userId: string,
  meetingId: string,
) {
  try {
    const response = await api().get(`/notes/meeting/${userId}/${meetingId}`);

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getNotesByUserIdAndCompanyId(
  userId: string,
  companyId: string,
  search: string,
) {
  try {
    const response = await api().get(`/notes/company/${userId}`, {
      headers: { companyId },
      params: {
        search,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function createNoteRequest(note: Partial<Note>, userId: string) {
  try {
    const response = await api().post('/notes', {
      ...note,
      owner_id: userId,
    });

    toast.success('Anotação criada com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function updateNoteRequest(
  note: Partial<Note>,
  noteId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().patch(
      `/notes/${noteId}`,
      {
        ...note,
      },
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    toast.success('Anotação editada com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function removeNoteRequest(noteId: string) {
  try {
    const response = await api().patch(`/notes/remove/${noteId}`);

    toast.success('Anotação excluída com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function deleteNoteRequest(noteId: string) {
  try {
    const response = await api().delete(`/notes/${noteId}`);

    toast.success('Anotação excluída com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte');
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}
